export default "__VITE_ASSET__ca0fbfd8__"